var header = document.querySelector('.ce_rsce_navigation');


window.addEventListener("scroll", function () {
  checkScrollPosition();
}, {passive: true});

function checkScrollPosition(){
  if(window.scrollY > 250){
    header.classList.add('scrolled');
  }else if (window.scrollY < 100) {
    header.classList.remove('scrolled');
  }
}
checkScrollPosition();
